import React from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { ProductOverview } from './components/ProductOverview';
import { Bonuses } from './components/Bonuses';
import { UrgencyBar } from './components/UrgencyBar';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-gradient-to-b from-[#EBF5FF] via-white to-[#EBF5FF] font-sans selection:bg-blue-600 selection:text-white" data-id="element-0">
      <Hero data-id="element-1" />
      <SocialProofBar data-id="element-2" />
      <Testimonials data-id="element-3" />
      <PainPoints data-id="element-4" />
      <ProductOverview data-id="element-5" />
      <Bonuses data-id="element-6" />
      <UrgencyBar data-id="element-7" />
      <Pricing data-id="element-8" />
      <Guarantee data-id="element-9" />
      <FAQ data-id="element-10" />
      <FinalCTA data-id="element-11" />
      <Footer data-id="element-12" />
    </div>;
}